import {Dispatch} from "redux";

import {IFetchContext} from "@pg-mono/data-fetcher";
import {appendQueryString, getRequest} from "@pg-mono/request";
import {createRequestActionTypes} from "@pg-mono/request-state";
import {apiV2ListLink, Scenario} from "@pg-mono/rp-api-routes";

import {IRPStore} from "../../app/rp_reducer";
import {IRPRequestMeta} from "../../app/rp_request_meta";
import {basePromotionCities} from "../helpers/promotion_cities";
import {promotionUrlParser} from "../helpers/promotion_url_parser";
import {PromotionType} from "../helpers/PromotionType";
import {IPromotionRegionStatistic} from "./fetch_promotion_region_statistic";

const FETCH_PROMOTION_CITIES_STATISTIC = "promotion_statistic/FETCH_CITIES";
export const fetchPromotionCitiesStatisticTypes = createRequestActionTypes(FETCH_PROMOTION_CITIES_STATISTIC);

interface IRegionDetailStats {
    promotions_count_total: number;
    promotions_count_promotions: number;
    promotions_count_open_days: number;
    promotions_count_discounts: number;
    promotions_count_last_minutes: number;
    promotions_count_presales: number;
}

interface ICityRegionResult {
    slug: string;
    stats: IRegionDetailStats | null;
}

interface ICityRegionListResponse {
    results: ICityRegionResult[];
}

// When adding a new PromotionType, ask BE to add a dedicated promotions_count_no_contribution field to the API so this subtraction can be replaced with a direct value from the response.
export const parseRegionStats = (stats: IRegionDetailStats): IPromotionRegionStatistic[] => {
    const noContributionCount = Math.max(
        0,
        stats.promotions_count_total -
            stats.promotions_count_promotions -
            stats.promotions_count_open_days -
            stats.promotions_count_discounts -
            stats.promotions_count_last_minutes -
            stats.promotions_count_presales
    );

    return [
        {type: PromotionType.PROMOTION, count: stats.promotions_count_promotions},
        {type: PromotionType.OPEN_DAYS, count: stats.promotions_count_open_days},
        {type: PromotionType.DISCOUNT, count: stats.promotions_count_discounts},
        {type: PromotionType.LAST_MINUTE, count: stats.promotions_count_last_minutes},
        {type: PromotionType.PRESALE, count: stats.promotions_count_presales},
        {type: PromotionType.NO_CONTRIBUTION, count: noContributionCount}
    ];
};

export const fetchPromotionCitiesStatisticAtRoute =
    (ctx: IFetchContext<IRPRequestMeta>) =>
    async (dispatch: Dispatch, getState: () => IRPStore): Promise<void> => {
        const friendlySlug = ctx.match?.params?.friendlySlug as string | undefined;

        if (friendlySlug) {
            const parsed = promotionUrlParser(friendlySlug);
            if (parsed?.region) {
                return;
            }
        }

        if (getState().promotionList.citiesStatistic) {
            return;
        }

        dispatch({type: fetchPromotionCitiesStatisticTypes.start});

        const url = appendQueryString(apiV2ListLink.region.list(Scenario.REGION_DETAIL), {
            region: basePromotionCities.map((city) => city.id),
            page_size: basePromotionCities.length
        });

        let response: ICityRegionListResponse;
        try {
            response = await getRequest(ctx.meta, url);
        } catch {
            dispatch({type: fetchPromotionCitiesStatisticTypes.error});
            return;
        }

        const citiesStatistic: Record<string, IPromotionRegionStatistic[]> = {};
        response.results.forEach((region) => {
            if (region.stats) {
                citiesStatistic[region.slug] = parseRegionStats(region.stats);
            }
        });

        dispatch({type: fetchPromotionCitiesStatisticTypes.success, result: citiesStatistic});
    };
import {Dispatch} from "redux";

import {IFetchContext} from "@pg-mono/data-fetcher";
import {appendQueryString, getRequest} from "@pg-mono/request";
import {createRequestActionTypes} from "@pg-mono/request-state";
import {apiV2ListLink, Scenario} from "@pg-mono/rp-api-routes";

import {IRPStore} from "../../app/rp_reducer";
import {IRPRequestMeta} from "../../app/rp_request_meta";
import {basePromotionCities} from "../helpers/promotion_cities";
import {promotionUrlParser} from "../helpers/promotion_url_parser";
import {PromotionType} from "../helpers/PromotionType";
import {IPromotionRegionStatistic} from "./fetch_promotion_region_statistic";

const FETCH_PROMOTION_CITIES_STATISTIC = "promotion_statistic/FETCH_CITIES";
export const fetchPromotionCitiesStatisticTypes = createRequestActionTypes(FETCH_PROMOTION_CITIES_STATISTIC);

interface IRegionDetailStats {
    promotions_count_total: number;
    promotions_count_promotions: number;
    promotions_count_open_days: number;
    promotions_count_discounts: number;
    promotions_count_last_minutes: number;
    promotions_count_presales: number;
}

interface ICityRegionResult {
    slug: string;
    stats: IRegionDetailStats | null;
}

interface ICityRegionListResponse {
    results: ICityRegionResult[];
}

// When adding a new PromotionType, ask BE to add a dedicated promotions_count_no_contribution field to the API so this subtraction can be replaced with a direct value from the response.
export const parseRegionStats = (stats: IRegionDetailStats): IPromotionRegionStatistic[] => {
    const noContributionCount = Math.max(
        0,
        stats.promotions_count_total -
            stats.promotions_count_promotions -
            stats.promotions_count_open_days -
            stats.promotions_count_discounts -
            stats.promotions_count_last_minutes -
            stats.promotions_count_presales
    );

    return [
        {type: PromotionType.PROMOTION, count: stats.promotions_count_promotions},
        {type: PromotionType.OPEN_DAYS, count: stats.promotions_count_open_days},
        {type: PromotionType.DISCOUNT, count: stats.promotions_count_discounts},
        {type: PromotionType.LAST_MINUTE, count: stats.promotions_count_last_minutes},
        {type: PromotionType.PRESALE, count: stats.promotions_count_presales},
        {type: PromotionType.NO_CONTRIBUTION, count: noContributionCount}
    ];
};

export const fetchPromotionCitiesStatisticAtRoute =
    (ctx: IFetchContext<IRPRequestMeta>) =>
    async (dispatch: Dispatch, getState: () => IRPStore): Promise<void> => {
        const friendlySlug = ctx.match?.params?.friendlySlug as string | undefined;

        if (friendlySlug) {
            const parsed = promotionUrlParser(friendlySlug);
            if (parsed?.region) {
                return;
            }
        }

        if (getState().promotionList.citiesStatistic) {
            return;
        }

        dispatch({type: fetchPromotionCitiesStatisticTypes.start});

        const url = appendQueryString(apiV2ListLink.region.list(Scenario.REGION_DETAIL), {
            region: basePromotionCities.map((city) => city.id),
            page_size: basePromotionCities.length
        });

        let response: ICityRegionListResponse;
        try {
            response = await getRequest(ctx.meta, url);
        } catch {
            dispatch({type: fetchPromotionCitiesStatisticTypes.error});
            return;
        }

        const citiesStatistic: Record<string, IPromotionRegionStatistic[]> = {};
        response.results.forEach((region) => {
            if (region.stats) {
                citiesStatistic[region.slug] = parseRegionStats(region.stats);
            }
        });

        dispatch({type: fetchPromotionCitiesStatisticTypes.success, result: citiesStatistic});
    };
